/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_HeadingInputs */

const en_visa_e2_heading = /** @type {(inputs: Visa_E2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How We Review E Cases`)
};

const pt_visa_e2_heading = /** @type {(inputs: Visa_E2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como Revisamos Casos E`)
};

const es_visa_e2_heading = /** @type {(inputs: Visa_E2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo Revisamos Casos E`)
};

/**
* | output |
* | --- |
* | "How We Review E Cases" |
*
* @param {Visa_E2_HeadingInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_heading = /** @type {((inputs?: Visa_E2_HeadingInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_HeadingInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_heading(inputs)
	if (locale === "es") return es_visa_e2_heading(inputs)
	return en_visa_e2_heading(inputs)
});